<script setup>
import Flickity from "flickity";
import ListCard from "@/Components/Cards/ListCard.vue";
import { computed, onMounted, ref } from "vue";
import { usePage } from "@inertiajs/vue3";

const props = defineProps({
    giftlists: {
        type: Array,
        required: true,
    },
    flickityOptions: {
        type: Object,
        required: false,
        default: () => ({}),
    },
});
const { giftlists } = props;

const flickity = ref(null);

const flickityInit = () => {
    const flickityInstance = new Flickity(
        flickity.value,
        Object.assign(
            {
                cellAlign: "center",
                freeScroll: true,
                freeScrollFriction: 0.1,
                pageDots: false,
                wrapAround: false,
            },
            props.flickityOptions,
        ),
    );
    flickityInstance.on("dragStart", () =>
        flickityInstance.slider.childNodes.forEach((slide) => {
            slide.style.pointerEvents = "none";
        }),
    );
    flickityInstance.on("dragEnd", () =>
        flickityInstance.slider.childNodes.forEach((slide) => {
            slide.style.pointerEvents = "all";
        }),
    );
};

const isLoggedIn = computed(() => {
    return !!usePage().props.auth.user?.data;
});

onMounted(() => {
    flickityInit();
});
</script>
<template>
    <div
        class="explore__experts--carousel"
        v-if="giftlists.length"
        ref="flickity"
    >
        <list-card
            :key="list.uuid"
            v-for="list in giftlists"
            :list="list"
            :logged-in="isLoggedIn"
            :owner="null"
            :show-list-card-options-menu="false"
            @click.stop
        ></list-card>
    </div>
</template>
